'use client';

import { Skeleton } from '@shared/components/shadcn';
import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type SportsbookBannerSkeletonProps = ComponentProps<'section'>;

function SportsbookBannerSkeletonCard() {
  return (
    <div className="flex w-[calc(100%-2.5rem)] min-w-0 shrink-0 flex-col overflow-hidden rounded-lg border border-border md:w-auto md:h-58 md:flex-row md:basis-154.75">
      <Skeleton className="aspect-video w-full md:aspect-auto md:basis-2/5" />
      <div className="flex flex-1 flex-col gap-4 p-6 md:basis-3/5 md:gap-3">
        <Skeleton className="h-5 w-24 rounded" />
        <Skeleton className="h-6 w-3/4 rounded" />
        <div className="mt-auto flex flex-col gap-2">
          <Skeleton className="h-10 w-32 rounded" />
          <Skeleton className="h-3 w-48 rounded" />
        </div>
      </div>
    </div>
  );
}

function SportsbookBannerSkeleton({ className, ...props }: SportsbookBannerSkeletonProps) {
  return (
    <section className={twMerge('w-full', className)} aria-labelledby="sportsbook-banner-carousel-title" data-testid="sportsbook-banner-carousel-skeleton" {...props}>
      <div className="w-full">
        <div className="hidden md:block">
          <Skeleton className="my-4 h-7 w-48 rounded" />
        </div>
        <div className="flex gap-4 overflow-hidden">
          <div className="flex w-full justify-center md:hidden">
            <SportsbookBannerSkeletonCard />
          </div>
          <div className="hidden w-full gap-4 md:flex">
            {[1, 2, 3].map(i => (
              <SportsbookBannerSkeletonCard key={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export { SportsbookBannerSkeleton };
